import { Entry, BaseModel, Form, EntryTypes } from '@ngx-resource-toolkit/core';
import { ValidationsHelper } from '../../helpers/validations.helper';
import { Validators, FormGroup } from '@angular/forms';
import { civiliteFetchOptions, lienParenteFetchOptions } from '../../resource/select-options';
import { TABLE } from '../../../app.constantes';
import { PhonePipe } from '../../pipes/phone.pipe';

const onChanges = (value: ResponsableModel, form: any) => {
    const nom: string = form.value['nom'];
    if (nom) {
        form.patchValue({nom: nom.toUpperCase()},  {emitEvent: false});
    }
    const prenom: string = form.value['prenom'];
    if (prenom) {
        form.patchValue({prenom: prenom.charAt(0).toUpperCase() + prenom.substring(1)},  {emitEvent: false});
    }
};

@Form({
    'create': {
        onChanges
    },
    'famille': {
        onChanges
    },
    'table': {},
})
export class ResponsableModel extends BaseModel {

    @Entry({
        'famille': {
            hidden: true
        },
        'create': {
            hidden: true
        },
        'table': {
            label: 'N°',
            minWidth: TABLE.MIN_WIDTH.ID,
            hidden: true
            // flexGrow: 1,
        }
    })
    id: number;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            placeholder: 'Civilité',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
            fetchOptions: civiliteFetchOptions,
        },
        'create': {},
        'famille': {},
        'table': {
            hidden: true,
            label: 'Civilité',
            // flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.ID,
            transform: (value) => value ? ( value.label ) : '',
        }
    })
    civilite: number;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            label: 'Civilité',
            hidden: true,
        },
        'table': {
            minWidth: TABLE.MIN_WIDTH.ID,
            hidden: false,
        }
    })
    civiliteLibelle: string;

    @Entry({
        base: {
            type: EntryTypes.SELECT,
            placeholder: 'Parenté',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
            fetchOptions: lienParenteFetchOptions,
        },
        'create': {},
        'famille': {},
        'table': {
            hidden: true,
            label: 'Parenté',
            // flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.PARENTE,
            transform: (value) => value ? ( value.label ) : '',
        }
    })
    lienParente: number;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            label: 'Parenté',
            hidden: true,
        },
        'table': {
            hidden: false,
            flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.PARENTE,
        }
    })
    parenteLibelle: string;

    @Entry({
        base: {
            validators: [Validators.required],
            validatorsMsgs: {
                'required': 'Le nom est obligatoire',
            },
            type: EntryTypes.TEXT,
            placeholder: 'Nom',
            flexGrow: 1,
            css:  {
                group: 'col-xs-6',
                input: '',
            },
        },
        'create': {},
        'famille': {},
        'table': {
            label: 'Nom',
            // flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
        }
    })
    nom: string;

    @Entry({
        base: {
            type: EntryTypes.TEXT,
            placeholder: 'Prénom',
            css:  {
                group: 'col-xs-6',
                input: '',
            },
        },
        'create': {},
        'famille': {},
        'table': {
            label: 'Prénom',
            // flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
        }
    })
    prenom: string;

    @Entry({
        base: {
            // validators: [ValidationsHelper.telephoneRegex()],
            // validatorsMsgs: {
            //     'telephoneFormat': 'Le téléphone n\'est pas valide',
            // }
            type: EntryTypes.NUMBER,
            placeholder: 'Téléphone mobile',
            css:  {
                group: 'col-xs-12',
                input: '',
            },
            validators: [ValidationsHelper.telephonePortableRegex()],
            validatorsMsgs: {
                'telephonePortableFormat': 'Le téléphone portable n\'est pas valide',
            }
        },
        'create': {},
        'famille': {},
        'table': {
            label: 'Tél Mobile',
            // flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.TEL,
            transform: (value) => value ? new PhonePipe().transform(value) : '',
        }
    })
    telephoneMobile: string;

    @Entry({
        base: {
            // validators: [ValidationsHelper.telephoneRegex()],
            // validatorsMsgs: {
            //     'telephoneFormat': 'Le téléphone n\'est pas valide',
            // }
            type: EntryTypes.NUMBER,
            placeholder: 'Téléphone professionnel',
            css:  {
                group: 'col-xs-12',
                input: '',
            },
            validators: [ValidationsHelper.telephoneRegex()],
            validatorsMsgs: {
                'telephoneFormat': 'Le téléphone professionnel n\'est pas valide',
            }
        },
        'create': {},
        'famille': {},
        'table': {
            label: 'Tél prof',
            // flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.TEL,
            transform: (value) => value ? new PhonePipe().transform(value) : '',
        }
    })
    telephoneProfessionnel: string;

    @Entry({
        base: {
            // validators: [ValidationsHelper.telephoneRegex()],
            // validatorsMsgs: {
            //     'telephoneFormat': 'Le téléphone n\'est pas valide',
            // }
            type: EntryTypes.NUMBER,
            placeholder: 'Téléphone domicile',
            css:  {
                group: 'col-xs-12',
                input: '',
            },
            validators: [ValidationsHelper.telephoneRegex()],
            validatorsMsgs: {
                'telephoneFormat': 'Le téléphone domicile n\'est pas valide',
            }
        },
        'create': {},
        'famille': {},
        'table': {
            label: 'Tél dom',
            // flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.TEL,
            transform: (value) => value ? new PhonePipe().transform(value) : '',
        }
    })
    telephoneDomicile: string;
    
    @Entry({
        base: {
            type: EntryTypes.TEXT,
            placeholder: 'Email',
            css:  {
                group: 'col-xs-12',
                input: '',
            },
            validators: [ValidationsHelper.emailRegex()],
            validatorsMsgs: {
                'emailFormat': 'L\'email n\'est pas valide',
            }
        },
        'create': {},
        'famille': {},
        'table': {
            label: 'Email',
            // flexGrow: 2,
            /*transform: (value) => value ? 
            '<a href="mailto:' + value + '">' + value + '</a>'
             : '',*/
            minWidth: TABLE.MIN_WIDTH.EMAIL,
        }
    })
    email: string;

    @Entry({
        base: {
            type: EntryTypes.CHECKBOX,
            css:  {
                group: 'col-xs-6',
                input: 'align-checkbox',
            },
            options: [{
                value: true,
                label: 'Principal'
            }]
        },
        'create': {},
        'famille': {},
        'table': {
            label: 'Principal',
            // flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.ID,
            transform: (value) => value ? 'X' : '',
        }
    })
    respPrincipal: boolean;

    @Entry({
        base: {},
        'famille': {
            hidden: true
        },
        'create': {
            hidden: true
        },
        'table': {
            hidden: true,
            label: 'N°',
            // flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.ID,
        }
    })
    familleId: number;

    // Appelé lors d'un add depuis le modèle
    initAfterCreate(data?) {
        console.log('initAfterCreate', typeof data, data);
        if (data.parentForm && data.parentForm.value) {
            const parent = data.parentForm.value; // normalement Famille
            this.familleId = parent.id; // si on est en création, il n'y a pas encore d'id
            this.nom = parent.nom;
        }
    }
    constructor(data) {
        super();
        Object.assign(this, data);
    }

}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/responsable/models/responsable.model.ts